import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export type DateFormatPreset =
  | "short"
  | "medium"
  | "long"
  | "monthDay"
  | "monthYear"
  | "monthYearLong"
  | "monthOnly"
  | "axis"
  | "shortDateTime"
  | "fullDateTime";

const DATE_FORMAT_OPTIONS: Record<DateFormatPreset, Intl.DateTimeFormatOptions> = {
  short: { year: "2-digit", month: "short", day: "numeric" },
  medium: { year: "numeric", month: "short", day: "numeric" },
  long: { year: "numeric", month: "long", day: "numeric" },
  monthDay: { month: "short", day: "numeric" },
  monthYear: { year: "numeric", month: "short" },
  monthYearLong: { year: "numeric", month: "long" },
  monthOnly: { month: "long" },
  axis: { month: "short", day: "2-digit" },
  shortDateTime: { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" },
  fullDateTime: { weekday: "long", year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "2-digit" },
};

export function useDateFormatter(preset: DateFormatPreset): Intl.DateTimeFormat {
  const { i18n } = useTranslation();
  return useMemo(() => new Intl.DateTimeFormat(i18n.language, DATE_FORMAT_OPTIONS[preset]), [i18n.language, preset]);
}
